import { deleteAllowance, deleteMultipleAllowances, getAllowances, selectAllowance, toggleAllowanceGroupAssignment, toggleCreateAllowance } from "store/entities/payroll/payrollSetup/action";
import CreateAllowanceModal from "components/__new/grossPayroll/allowances/CreateAllowanceModal";
import { useEffect, useState, useMemo } from "react";
import Table from "components/__new/common/Table";
import DateFormat from "utils/dateFormat";
import SearchBox from "components/__new/common/SearchBox";
import BulkActionHandler from "components/__new/common/BulkActionHandler";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import processParams from "utils/processParams";
import useUrlQueryParams from "hooks/useUrlQueryParams";
import useUrlNavigation from "hooks/useUrlNavigation";
import IconEmptyBox from "assets/images/icons/project-icons/empty-box.png";
import Pagination from "components/__new/common/pagination";
import Maybe from "components/__new/common/Maybe";
import SortBy from "components/__new/common/SortBy";
import { useLocation } from "react-router-dom";
import DialogBox from "utils/dialogBox";
import { ReactComponent as IconDotH } from "assets/images/icons/project-icons/dots-v.svg";
import usePayrollEssentials from "hooks/usePayrollEssentials";
import { TableContent } from "components/__new/common/TableContent";
import Spinner from "components/__new/common/Spinner";
import AllowancePayGroupsAssignmentModal from "components/__new/grossPayroll/allowances/AllowancePayGroupsAssignmentModal";
import logger from "utils/logger";
import useLoginInfo from "hooks/useLoginInfo";
import DropdownNew from "utils/dropdown";
import DeleteAllowance from "components/__new/payroll/DeleteAllowance";
import { toast } from "react-toastify";
import ViewAllowanceDetails from "components/__new/payroll/ViewAllowanceDetails";
import Filter, { ActiveFilter } from "components/__new/common/Filter";

export const Allowances = () => {
    const location = useLocation()
    const {dispatch, useSelector, AssignmentLabel, history, EmptyDataUI, truncator} = usePayrollEssentials()

    const {urlQuery} = useUrlNavigation();
    const [batch, setBatch] = useState([]);
    const {urlQueryParams} = useUrlQueryParams();
    const {userInfo} = useLoginInfo();

    const {getAllowanceData: allowancesData, getAllowanceLoading: loading, deleteAllowanceResponse, isAllowanceModalOpen, deleteAllowanceLoading, deleteBatchAllowanceLoading} = useSelector(state => state.entities.payrollSetup);
    const allowanceValid = !loading && allowancesData?.data?.length > 0
    const allAllowanceIDs = allowancesData?.data?.map(item => item.id)
    const [listParams, setListParams] = useState({ "page": 1, "limit": 10 });
    const [isOpenDeleteAllowance, setIsOpenDeleteAllowance] = useState(false);
    const [allowance, setAllowance] = useState({});
    const [isEditMode, setIsEditMode] = useState(false);
    const [isAllowanceFormOpen, setIsAllowanceFormOpen] = useState(false);
    const [isOpenAllowanceDetails, setIsOpenAllowanceDetails] = useState();
    const [sortOptions, setSortOptions] = useState([
        {
            title: <>Date Created <FontAwesomeIcon icon="arrow-up" className="ml-2 mt-0.5" /></>,
            link: urlQuery("sort=createdAt&order=asc"),
            data: {sort: 'createdAt', order: 'asc'},
            active: false,
        },
        {
            title: <>Date Created <FontAwesomeIcon icon="arrow-down" className="ml-2 mt-0.5" /></>,
            link: urlQuery("sort=createdAt&order=desc"),
            data: {sort: 'createdAt', order: 'desc'},
            active: false,
        },
    ]);
    
    const paginationData = useMemo(() => {
        if (!allowancesData?.data) return {};
        
        const { data, ...paginationInfo } = allowancesData;
        return paginationInfo;
    }, [allowancesData])

    const fetchAllowanceItems = () => {
        let params = {...listParams};

        params = processParams(urlQueryParams, params, "page", "number", 1, "page");
        params = processParams(urlQueryParams, params, "limit", "number", 10, "limit");
        params = processParams(urlQueryParams, params, "status", "string", "", "status");
        params = processParams(urlQueryParams, params, "search", "string", "", "search");
        params = processParams(urlQueryParams, params, "sort", "string", "", "sortBy");
        params = processParams(urlQueryParams, params, "order", "string", "", "sortOrder");
        
        params = processParams(urlQueryParams, params, "startDate", "string", "", "startDate");
        params = processParams(urlQueryParams, params, "endDate", "string", "", "endDate");
        params = processParams(urlQueryParams, params, "dateRange", "string", "", "dateRange"); 

        const sortValue = urlQueryParams["sort"];
        const orderValue = urlQueryParams["order"];
        if (sortValue && orderValue) {
            const newSortOptions = sortOptions?.map((sortOption) => {
                if (sortOption?.data?.sort === sortValue && sortOption?.data?.order === orderValue) {
                    return {...sortOption, active: true};
                }
                else {
                    return {...sortOption, active: false};
                }
            })
            setSortOptions(newSortOptions);
        }

        setListParams(params);
        dispatch(getAllowances(params))
    }

    const toggleSingleItem = (id) => {
        const alreadyExists = batch?.indexOf(id) > -1
        if (alreadyExists) {
            const filtered = batch?.filter(item => item !== id)
            setBatch(filtered)
        } else {
            setBatch([...batch, id])
        }
    }

    const toggleEntireList = () => {
        if (batch.length !== allAllowanceIDs?.length) {
            setBatch(allAllowanceIDs)
        } else {
            setBatch([])
        }
    }

    const deleteAllowanceAndBonus = async () => {
        dispatch(deleteAllowance(allowance?.id));
        // setIsOpenDeleteAllowance(false);
        // toast.success('Allowance successfully deleted');
        // const result = await DialogBox({
		// 	title: "Delete Allowance 😰",
        //     content: <div className="delete-modal-text">Are you sure you want to delete <span className="delete-modal-highlight">{truncator(item.name)}</span>? This action cannot be undone.</div>,
		// 	buttonYes: "Delete",
        //     buttonYesClass: "btn-ep-red",
		// 	buttonNo: "Cancel",
		// });
		// if (result) {
        //     dispatch(deleteAllowance(item.id));
        // }
    }

    const handleBulkDelete = async () => {
        const result = await DialogBox({
			title: "Delete Allowance 😰",
            content: <div className="delete-modal-text">Are you sure you want to delete <span className="delete-modal-highlight">{batch?.length} allowances</span>? This action cannot be undone.</div>,
			buttonYes: "Delete",
            buttonYesClass: "btn-ep-red",
			buttonNo: "Cancel",
		});
		if (result) {
            dispatch(deleteMultipleAllowances({ids: batch})).then(() => setBatch([]));
        }
    }

    const handleToggleAllowanceForm = () => {
        if(!isAllowanceFormOpen) {
            logger("Employer-Payroll-setup-allowance-create-attempt", userInfo);
        }
        // dispatch(toggleCreateAllowance())
        setIsAllowanceFormOpen(!isAllowanceFormOpen);
    }
    
    const handleEditForm = () => {
        setIsEditMode(true);
        handleToggleAllowanceForm();
    }

    useEffect(() => {
        fetchAllowanceItems();
        //eslint-disable-next-line
    }, [location])
    
    
    useEffect(() => {
        if(deleteAllowanceResponse?.id !== undefined || deleteAllowanceResponse?.count !== undefined) {
            history.push({ ...urlQueryParams, page: 1 });
            // fetchAllowanceItems();
            setIsOpenDeleteAllowance(false);
        }
        // eslint-disable-next-line
    }, [deleteAllowanceResponse])
    
    return (
        <div>
            <AllowancePayGroupsAssignmentModal allowance={allowance} />
            
            <CreateAllowanceModal 
                handleToggleAllowanceForm={handleToggleAllowanceForm} 
                userInfo={userInfo}
                logger={logger}
                isAllowanceFormOpen={isAllowanceFormOpen}
                isEditMode={isEditMode}
                setIsEditMode={setIsEditMode}
                allowance={allowance}
            />
            
            <ViewAllowanceDetails
                isOpen={isOpenAllowanceDetails}
                setIsOpen={setIsOpenAllowanceDetails}
                allowance={allowance}
                handleEditForm={handleEditForm}
            />

            <DeleteAllowance
                loading={deleteAllowanceLoading}
                isOpen={isOpenDeleteAllowance}
                setIsOpen={setIsOpenDeleteAllowance}
                onProceed={deleteAllowanceAndBonus}
            />

            {/* {loading === true && <Spinner message="Fetching Allowances" />} */}

            {/* {urlQueryParams?.search === undefined && loading === false && allowancesData?.data && allowancesData?.data?.length === 0 &&
                <EmptyDataUI
                    subheader={<span>Let's create custom allowances that fit your organization. You can <br /> create as many as needed</span>}
                    onBtnClick={handleToggleAllowanceForm}
                    btnText="+ Create Allowance" />
            } */}

            {/* {loading === false && (urlQueryParams?.search !== undefined || !allowancesData?.data || allowancesData?.data?.length > 0) && */}
            <>

                <div className="box !px-0 !pb-0">
                    <div className="px-6 font-medium text-xl">
                        Allowance and Bonus
                    </div>

                    <div className={`px-6 mt-6 xl:flex flex-wrap ${batch?.length > 0 ? "justify-start" : "justify-between"}`}>
                        <div className="flex-grow flex items-center">
                            <div className="flex mr-4">
                                <input type="checkbox" className="form-checkbox w-5 h-5 multi-select-header" onChange={toggleEntireList}
                                    checked={allAllowanceIDs?.length > 0 && batch.length === allAllowanceIDs?.length}
                                />
                            </div>
                            {/* <Maybe condition={batch?.length === 0}>
                                <div className="w-10 flex justify-center items-center">
                                    <IconDotH className="h-6 svg-fill-ccc" />
                                </div>
                            </Maybe> */}
                            <Maybe condition={batch?.length > 0}>
                                <div className="flex items-center" style={{ marginLeft: "7px" }}>
                                    <BulkActionHandler
                                        count={batch?.length}
                                        onCancel={() => setBatch([])}
                                        onDelete={handleBulkDelete}
                                        hideThreeDot={true}
                                    />
                                </div>
                            </Maybe>
                            <Maybe condition={batch?.length === 0}>
                                <div className="w-full max-w-sm sm:mr-6">
                                    <SearchBox placeholder="Search for allowances" name="search" extraUrlParams="page=1" />
                                </div>
                            </Maybe>
                        </div>
                        <Maybe condition={batch?.length === 0}>
                            <div className="mt-2 xl:mt-0 flex flex-wrap space-x-3 sm:space-x-6">

                                    {/* <div>
                                        <Filter filters={[
                                            {
                                            title: "Status",
                                            name: "status",
                                            dataType: "select",
                                            options: [
                                                {
                                                    display: "All",
                                                    payload: "",
                                                },
                                                {
                                                    display: "Assigned",
                                                    payload: "assigned",
                                                },
                                                {
                                                    display: "Unassigned",
                                                    payload: "unassigned",
                                                },
                                            ],
                                        },
                                        ]}/>
                                    </div> */}
                                {/* <div>
                                    <SortBy options={sortOptions} title="Sort Order: " firstOption='Select' />
                                </div> */}
                                
                                <div>
                                    <Filter 
                                        filters={[
                                            {
                                                title: "Date range",
                                                name: "dateRange",
                                                dataType: "custom-timeframe",
                                                hasResetButton: true,
                                                options: [
                                                    {
                                                        display: "Today",
                                                        payload: "today",
                                                    },
                                                    {
                                                        display: "Last 7 days",
                                                        payload: "last_7_days",
                                                    },
                                                    {
                                                        display: "30 days",
                                                        payload: "30_days",
                                                    },
                                                    {
                                                        display: "1 Year",
                                                        payload: "1_year",
                                                    },
                                                ],
                                            },
                                            {
                                                title: "Custom date range",
                                                dataType: "date-range",
                                                options: {
                                                    from: {
                                                        name: "startDate",
                                                        placeholder: "Start Date",
                                                    },
                                                    to: {
                                                        name: "endDate",
                                                        placeholder: "End Date",
                                                    },
                                                },
                                            },
                                        ]}
                                    />
                                </div>
                                
                                <div className="payroll-setup-main-page-action">
                                    <button disabled={loading} onClick={handleToggleAllowanceForm} className="btn btn-md btn-ep-primary">
                                        <FontAwesomeIcon icon="plus" className="mr-2" />
                                        Create Allowance and Bonus
                                    </button>
                                </div>

                            </div>
                        </Maybe>
                    </div>
                    
                    <div className="px-6">
                        <ActiveFilter 
                            filters={{
                                "Date range": "dateRange",
                                "Period start date": "startDate", 
                                "Period end date": "endDate",
                            }} 
                        />
                    </div>

                    <div className="mt-6">
                        <div>

                            <Table>
                                <Table.Head>
                                    <th style={{ paddingRight: 0, paddingLeft: "1.5rem" }}></th>
                                    <th style={{ paddingLeft: 0 }}>Allowance Name</th>
                                    <th>Allowance Type</th>
                                    <th>Rate Source</th>
                                    <th>Date Created</th>
                                    <th></th>
                                </Table.Head>
                                <Table.Body>

                                    <TableContent
                                        loading={loading || deleteBatchAllowanceLoading}
                                        loadingText={`${deleteBatchAllowanceLoading ? "Deleting Multiple Allowance" : "Fetching Allowances"}`}
                                        data={allowancesData?.data}
                                        total={allowancesData?.data?.length}
                                        colspan={24}
                                        emptyUI={<>
                                            <div className="py-20 mx-auto text-center text-base">
                                                <div className="flex justify-center">
                                                    <img src={IconEmptyBox} alt="Empty" className="h-48" />
                                                </div>
                                                <div className="text-[#101828] font-medium">
                                                    No Data Available
                                                </div>
                                                <div onClick={handleToggleAllowanceForm} className="mt-1 underline cursor-pointer text-[#4A5564]">
                                                    Click here to create allowance and bonus
                                                </div>
                                            </div>
                                        </>}
                                    />

                                    {(!loading && !deleteBatchAllowanceLoading) && allowancesData?.data?.map((item, index) => {
                                        // const employeePays =  item?.tax_payer === 'EMPLOYEE'
                                        // const employerPays =  item?.tax_payer === 'EMPLOYER'

                                        return (
                                            <tr key={index}>
                                                <td style={{ paddingRight: "15px", paddingLeft: "1.5rem", width: "20px" }}>
                                                    <input
                                                        type="checkbox"
                                                        className="form-checkbox w-5 h-5 multi-select"
                                                        onChange={() => toggleSingleItem(item?.id)}
                                                        checked={batch?.includes(item?.id)}
                                                        value={item?.id}
                                                    />
                                                </td>
                                                <td style={{ paddingLeft: 0, width: "350px" }}>
                                                    <div className="capitalize">
                                                        {item.name.toLowerCase()}
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="capitalize">
                                                        {item.type.toLowerCase()}
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="capitalize">
                                                        {item?.source?.replaceAll("_", " ")?.toLowerCase()}
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="lt-gray">
                                                        {DateFormat(item?.createdAt)}
                                                    </div>
                                                </td>
                                                {/* <td>
                                                    {item?.isTaxable === true ? "Taxable (Employee)" : "Non-Taxable"}
                                                </td> */}
                                                {/* <td>
                                                    <AssignmentLabel isAssigned={item?.status === "assigned"} />
                                                </td> */}
                                                <td>
                                                    {/* <div className="flex items-center">
                                                        <Maybe condition={item?.status === 'unassigned'}>
                                                            <button onClick={() => {
                                                                dispatch(selectAllowance(item));
                                                                dispatch(toggleAllowanceGroupAssignment());
                                                            }} className="text-ep-primary-500 mr-3">Assign</button>
                                                        </Maybe>
                                                        
                                                        <button onClick={() => {
                                                            dispatch(selectAllowance(item));
                                                            history.push({ pathname: `/payroll-configuration/allowances/${item.id}/view`, state: { payload: item }})
                                                        }} className="text-ep-primary-500 mr-3">View</button>
                                                        
                                                        <button onClick={() => {
                                                            handleDelete(item)
                                                        }} className="text-ep-danger">Delete</button>
                                                    </div> */}
                                                    
                                                    <DropdownNew iconClassName="rotate-90">
                                                        <></>
                                                        <div>
                                                            <div 
                                                                onClick={() => {
                                                                    setAllowance(item);
                                                                    setIsOpenAllowanceDetails(true);
                                                                }} 
                                                                className="dropdown-item"
                                                            >
                                                                View
                                                            </div>
                                                            <div 
                                                                onClick={() => {
                                                                    setAllowance(item);
                                                                    handleEditForm();
                                                                }} 
                                                                className="dropdown-item"
                                                            >
                                                                Edit
                                                            </div>
                                                            <div 
                                                                onClick={() => {
                                                                    setAllowance(item);
                                                                    dispatch(toggleAllowanceGroupAssignment())    
                                                                }} 
                                                                className="dropdown-item"
                                                            >
                                                                Assign to group
                                                            </div>
                                                            <div 
                                                                onClick={() => {
                                                                    setAllowance(item)
                                                                    setIsOpenDeleteAllowance(true)
                                                                }} 
                                                                className="dropdown-item text-red-500"
                                                            >
                                                                Delete
                                                            </div>
                                                        </div>
                                                    </DropdownNew>
                                                </td>
                                            </tr>
                                        )}
                                    )}

                                </Table.Body>
                            </Table>

                            <Maybe condition={allowanceValid}>
                                <div className="mt-6">
                                    <Pagination data={paginationData} limit={paginationData?.limit} />
                                </div>
                            </Maybe>

                        </div>
                    </div>
                </div>
            </>
            {/* } */}
            </div>
        )
}


export default Allowances;